import { faCalendar, faClock, faTachometerAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IMaintenanceReview } from 'app/shared/model/maintenance-review.model';
import React from 'react';
import { translate } from 'react-jhipster';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { PartsViewModal } from '../part/PartsViewModal';

interface IMaintenanceReviewModalProps {
  maintenanceReview: IMaintenanceReview;
  toggle: any;
  isOpen: boolean;
}

export const MaintenanceReviewModal = ({ maintenanceReview, toggle, isOpen }: IMaintenanceReviewModalProps) => {
  const [modalOpen, setModalOpen] = React.useState(false);

  const SectionValues = [
    {
      name: 'Distância (km)',
      icon: faTachometerAlt,
      value: maintenanceReview.km ?? '-',
    },
    {
      name: 'Tempo (meses)',
      icon: faCalendar,
      value: maintenanceReview.period ?? '-',
    },
    /*
    {
      name: 'Horas de operação',
      icon: faClock,
      value: maintenanceReview.hour ?? '-',
    },
    */
  ];

  return (
    <>
      <Modal className="modal-parts" isOpen={isOpen} toggle={toggle} zIndex={9999}>
        <ModalHeader toggle={toggle}>{translate('fleetSenseApp.maintenanceReview.reviewOrder') + ': ' + maintenanceReview?.reviewOrder}</ModalHeader>
        <ModalBody>
          <div className="modal-title-values">
            <strong>
              Próxima Manutenção <br />
            </strong>
          </div>
          <div className="part-values">
            {SectionValues.map((item, index) => (
              <React.Fragment key={index}>
                <div className="col-3 part-data-value">
                  <FontAwesomeIcon icon={item.icon} style={{ color: '#2cb4b4' }} />
                  <p style={{ color: '#2cb4b4' }}>{item.name}</p>
                  <span>
                    <p>
                      <strong>{item.value}</strong>
                    </p>
                  </span>
                </div>
              </React.Fragment>
            ))}
          </div>
          {maintenanceReview?.maintenanceModel?.name && (
            <div className="modal-description-part">
              <div className="modal-title-description">
                <strong>
                  {translate('fleetSenseApp.maintenanceReview.maintenanceModel')} <br />
                </strong>
              </div>
              <div className="modal-description-text">{maintenanceReview?.maintenanceModel?.name}</div>
            </div>
          )}
          {maintenanceReview?.description && (
            <div className="modal-description-part">
              <div className="modal-title-description">
                <strong>
                  Descrição <br />
                </strong>
              </div>
              <div className="modal-description-text">{maintenanceReview?.description}</div>
            </div>
          )}
          <ModalFooter className="m-0 p-0">
            <Button
              outline
              color="info"
              onClick={() => setModalOpen(true)}
            >
              {translate('fleetSenseApp.maintenanceReview.part')}
            </Button>
          </ModalFooter>
        </ModalBody>
      </Modal>
      <PartsViewModal modalOpen={modalOpen} setModalOpen={setModalOpen} maintenanceReviewId={maintenanceReview.id}/>
    </>
  );
};
